export default {
  BASE_URL: "https://backend-kovan.epns.io/apis",
  YOUTUBE_API_KEY: "AIzaSyBrzkFPyNmVDFzGY7dKz2HocUO4m-ni-Fc",
  EPNS_CORE_CONTRACT: "0x97D7c5f14B8fe94Ef2b4bA589379f5Ec992197dA",
  EPNS_COMMUNICATOR_CONTRACT: "0xb3971BCef2D791bc4027BbfedFb47319A4AAaaAa",
};
